<script>
import { required } from "vuelidate/lib/validators";
import { cloneDeep } from "lodash";
import groupBy from "lodash/groupBy";
import Multiselect from "vue-multiselect";
import Tracks from "@/components/modals/document-tracks.vue";
import Details from "@/components/widgets/document-tracking-details";
import CreateDetails from "@/router/views/dts/dts-modal/details";
import PrintOptions from "@/components/modals/print-options.vue";

export default {
  name: "DocumentTracking",
  components: {
    Multiselect,
    Tracks,
    Details,
    CreateDetails,
    PrintOptions,
  },
  data() {
    return {
      referenceNumber: "",
      officeIncomingCount: 0,
      departmentIncomingCount: 0,
      submitted: false,
      modalTitle: "",
      form: {
        deliveryUnitId: "",
        departmentId: "",
        title: "",
        description: "",
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationCampus: null,
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: []
      },
      campusOptions: [],
      departmentOptions: [],
      processTypeOptions: [],
      actionTypeOptions: [],
      formLoading: false,
      campusId: this.$store.state.data.selectedCampus.id,
      selectedDU: this.$store.state.data.selectedDU,
      selectedDepartment: this.$store.state.data.selectedDepartment,
      sendAsOptions: [
        { text: 'Office', value: 'office' },
        { text: 'Department', value: 'department' }
      ],
      selectedSendAs: 'office',
      showAllCampus: false,
      dus: [],
      processTypesDUs: []
    };
  },
  watch: {
    "showAllCampus": function (value) {
      this.form.destinationCampus = null;
      this.form.destinationDeliveryUnit = null;
      this.form.destinationDepartment = null;
      this.form.destinationDepartmentId = "";
      if (value) {
        this.campusOptions = this.groupDu(this.dus);
      } else {
        this.campusOptions = this.groupDu(this.processTypesDUs);
      }
    },
  },
  validations: {
    form: {
      title: { required },
      description: { required },
      destinationDeliveryUnit: { required },
      destinationCampus: { required },
      processType: { required },
      actionType: { required },
      documents: { required }
    }
  },
  created() {
    this.getAllDUs();
  },
  methods: {
    getTrack() {
      if (this.referenceNumber == "") {
        this.showToast("Invalid tracking number.", "warning");
        return;
      }
      this.$store
        .dispatch("dtstrack/GetTrackByReferenceNumber", {
          deliveryUnitId: this.$store.state.data.selectedDU.id,
          stringData: this.referenceNumber.trim(),
        })
        .then((res) => {
          this.viewDetails(res.data);
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Invalid tracking number.", "warning");
          } else {
            this.showToast("Something went wrong - Getting track!", "error");
          }
        });
    },
    setCount(officeIncomingCount, departmentIncomingCount) {
      this.officeIncomingCount = officeIncomingCount;
      this.departmentIncomingCount = departmentIncomingCount;
    },
    viewDetails(props) {
      this.$refs.details.getData(props);
    },


    onSubmit(type) {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid || this.form.documents.length == 0) {
        return;
      }
      this.form.destinationDeliveryUnitId = this.form.destinationDeliveryUnit.id;
      this.form.destinationDepartmentId = this.form.destinationDepartment.id;
      this.form.processTypeId = this.form.processType.id;

      // Set department ID based on selection
      if (this.selectedSendAs === 'department') {
        this.form.departmentId = this.selectedDepartment.id;
      } else {
        this.form.departmentId = 0; // 0 means send as office
      }

      if (this.form.actionType.type != "Others")
        this.form.actionNeeded = this.form.actionType.type;
      this.$store
        .dispatch("dtstrack/CreateTrack", this.form)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          if (this.form.tracks.length > 0) {
            var newTrack = res.data;
            this.$store
              .dispatch("dtstrack/MergeTrack", {
                parentId: newTrack.id,
                array: this.form.tracks
              })
              .then((res) => {
                if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
                }
                if (type == "send") {
                  this.$store
                    .dispatch("dtstrack/PostTrack", newTrack.id)
                    .then((res) => {
                      if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                      }
                      let dashboardData = JSON.parse(
                        localStorage.getItem("dashboardData")
                      );
                      dashboardData.incomingTracks =
                        dashboardData.incomingTracks + 1;
                      localStorage.setItem(
                        "dashboardData",
                        JSON.stringify(dashboardData)
                      );
                      this.$refs.createDetails.getData(newTrack.id);
                    })
                    .catch((err) => {
                      this.showToast("Cannot be sent!", "error");
                    });
                }
                this.$bvModal.hide("modal-documentTrack");
                this.showToast("Successfully created!", "success");
              });
          } else {
            if (type == "send") {
              this.$store
                .dispatch("dtstrack/PostTrack", res.data.id)
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  let dashboardData = JSON.parse(
                    localStorage.getItem("dashboardData")
                  );
                  dashboardData.incomingTracks =
                    dashboardData.incomingTracks + 1;
                  localStorage.setItem(
                    "dashboardData",
                    JSON.stringify(dashboardData)
                  );
                  this.$refs.createDetails.getData(res.data.id);
                })
                .catch((err) => {
                  this.showToast("Cannot be sent!", "error");
                });
            }
            this.$bvModal.hide("modal-documentTrack");
            this.showToast("Successfully created!", "success");
          }
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    createTrack() {
      this.formLoading = true;
      this.modalTitle = "Create Track";
      this.$bvModal.show("modal-documentTrack");
      this.onReset();
      this.getProcessType();
      this.getActionType();
      this.formLoading = false;
    },
    async onReset() {
      this.submitted = false;
      this.form = {
        deliveryUnitId: this.selectedDU.id,
        departmentId: 0,
        title: "",
        description: "",
        destinationDepartmentId: "",
        destinationDepartment: [{ departmentName: "N/A", id: 0 }],
        destinationDeliveryUnitId: "",
        destinationDeliveryUnit: null,
        destinationCampus: null,
        processTypeId: "",
        processType: null,
        actionNeeded: "",
        actionType: null,
        documents: [],
        document: "",
        tracks: []
      };
      this.campusOptions = [];
      this.processTypeOptions = [];
      this.actionTypeOptions = [];
    },
    addDocument() {
      if (this.form.document.trim() != "") {
        this.form.documents.push(this.form.document);
        this.form.document = "";
      }
    },
    removeDocument(index) {
      this.form.documents.splice(index, 1);
    },
    async changeProcessType() {
      await this.getDeliveryUnit();
      this.form.actionNeeded = "";
      this.form.actionType = null;
      this.form.destinationDepartmentId = "";
      this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
      this.form.destinationDeliveryUnitId = "";
      this.form.destinationDeliveryUnit = null;
      this.form.destinationCampus = null;
    },
    async getDocuments(props) {
      this.$store
        .dispatch("dtstrackdocument/GetTrackDocument", props.id)
        .then((res) => {
          for (var count = 0; count < res.data.length; count++) {
            props.documents.push(res.data[count].title);
          }
        });
    },
    async getAllDUs() {
      this.$store
        .dispatch("deliveryunit/GetDeliveryUnit")
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.dus = res.data.sort(function (a, b) {
            if (a.name.trim().trim() < b.name.trim()) {
              return -1;
            }
            if (a.name.trim() > b.name.trim()) {
              return 1;
            }
            return 0;
          }).filter(item => !item.office.campus.campusName.toLowerCase().includes('test')).map((item) => {
            return {
              id: item.id,
              name: item.name.trim(),
              campusId: item.office.campusId,
              campus: item.office.campus.campusName
            };
          });
        })
        .catch((err) => {
          this.showToast("Something went wrong - Getting campuses!", "error");
        });
    },
    groupDu(props) {
      var array = [];
      var x = groupBy(props, "campusId");
      for (const key in x) {
        array.push({
          campusId: key,
          campus: x[key][0].campus,
          deliveryUnitOptions: x[key]
        });
      }
      return array;
    },
    async getDeliveryUnit() {
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", this.form.processType.id)
        .then((res) => {
          if (res.data.error) {
            return;
          }
          this.processTypesDUs = res.data.sort(function (a, b) {
            if (a.name < b.name) {
              return -1;
            }
            if (a.name > b.name) {
              return 1;
            }
            return 0;
          });
          this.campusOptions = this.groupDu(this.processTypesDUs);
        });
    },
    async getDepartment(duId) {
      this.form.destinationDepartment = [{ departmentName: "N/A", id: 0 }];
      this.$store.dispatch("department/GetDepartmentByDU", duId).then((res) => {
        if (res.data.error || res.data.length < 2) {
          return;
        }
        this.departmentOptions = res.data
          .sort(function (a, b) {
            if (a.departmentName < b.departmentName) {
              return -1;
            }
            if (a.departmentName > b.departmentName) {
              return 1;
            }
            return 0;
          })
          .filter((item) => {
            return this.selectedDepartment.id != item.id;
          });
        this.departmentOptions.unshift({ departmentName: "N/A", id: 0 });
      });
    },
    campusLabel({ campus }) {
      return `${campus}`;
    },
    deliveryUnitLabel({ name }) {
      return `${name}`;
    },
    departmentLabel({ departmentName }) {
      return `${departmentName}`;
    },
    async getProcessType() {
      this.$store.dispatch("dtsprocesstype/GetProcessType").then((res) => {
        this.processTypeOptions = res.data.sort(function (a, b) {
          if (a.processName < b.processName) {
            return -1;
          }
          if (a.processName > b.processName) {
            return 1;
          }
          return 0;
        });
      });
    },
    processTypeLabel({ processName }) {
      return `${processName}`;
    },
    async getActionType() {
      this.$store.dispatch("dtsactiontype/GetActionType").then((res) => {
        this.actionTypeOptions = res.data.sort(function (a, b) {
          if (a.type < b.type) {
            return -1;
          }
          if (a.type > b.type) {
            return 1;
          }
          return 0;
        });
        this.actionTypeOptions.push({ type: "Others" });
      });
    },
    async refreshOptions() {
      this.formLoading = true;
      await this.getProcessType();
      await this.getActionType();
      if (this.form.processType) {
        await this.getDeliveryUnit();
        if (this.form.destinationCampus) {
          let campusId = this.form.destinationCampus.campusId;
          this.form.destinationCampus = this.campusOptions.find(
            (x) => x.campusId == campusId
          );
        }
      }
      setTimeout(() => {
        this.formLoading = false;
      }, 500);
    },
    getTracks() {
      this.$refs.tracks.setData(this.form.tracks, this.selectedDU.id, 0);
      this.$bvModal.show("tracks-modal");
    },
    dropTracks(data) {
      this.form.tracks = data.concat(this.form.tracks);
    },
    actionTypeLabel({ type }) {
      return `${type}`;
    },

    async updateTrack(props) {
      this.formLoading = true;
      this.modalTitle = "Update Track";
      this.$bvModal.show("modal-documentTrack");
      await this.onReset();
      await this.getProcessType();
      await this.getActionType();
      this.form.id = cloneDeep(props.id);
      this.form.title = cloneDeep(props.title);
      this.form.description = cloneDeep(props.description);
      await this.getDocuments(this.form);
      this.form.processType = cloneDeep(props.processType);
      await this.getDeliveryUnit();
      this.$store
        .dispatch("dtsprocesstype/GetDUByProcessType", this.form.processType.id)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.campusOptions = this.groupDu(
            res.data
              .sort(function (a, b) {
                if (a.name < b.name) {
                  return -1;
                }
                if (a.name > b.name) {
                  return 1;
                }
                return 0;
              })
              .filter((item) => {
                return this.selectedDU != item.id;
              })
          );
          this.form.destinationCampus = this.campusOptions.find(
            (x) => x.campusId == props.destinationDeliveryUnit.campusId
          );
          this.form.destinationDeliveryUnit = cloneDeep(
            props.destinationDeliveryUnit
          );
          this.form.destinationDepartment = props.destinationDepartment
            ? cloneDeep(props.destinationDepartment)
            : [{ departmentName: "N/A", id: 0 }];
          this.form.actionType = { type: props.actionNeeded };
          this.formLoading = false;
        });
    },
    deleteTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/DeleteTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    postTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to send this track.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, send it!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/PostTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.incomingTracks = dashboardData.incomingTracks + 1;
              if (props.status == "RETURNED")
                dashboardData.returnedTracks = dashboardData.returnedTracks - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.$refs.createDetails.getData(res.data.id);
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully sent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be sent!", "error");
            });
        }
      });
    },
    unsendTrack(props) {
      this.$swal({
        position: "top",
        title: "Are you sure?",
        text: "You are about to unsend this track.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#ff9f43",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, unsend track!",
        allowOutsideClick: false
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("dtstrack/UnsendTrack", props.id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var index = this.tableData.findIndex(
                (item) => item.id == props.id
              );
              this.tableData.splice(index, 1);
              this.showToast("Successfully unsent", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be unsent!", "error");
            });
        }
      });
    },
    async printSingleTrackingReport(id) {
      var apiUrl = `dts/api/Report/Tracking`;
      var routeVariables = [];
      var body = [];
      body.push({ id: id });
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
        body: body
      });
      this.$bvModal.show("print-options-modal");
    }
  },
};
</script>

<template>
  <div>
    <!-- Create Track -->
    <b-modal id="modal-documentTrack" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <div v-if="formLoading" class="my-5">
        <div class="d-flex align-items-center justify-content-center">
          <div class="preloader-component me-2">
            <div class="status">
              <div class="spinner-chase w-25px h-25px">
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
                <div class="chase-dot"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <div>
          <div class="d-flex justify-content-end">
            <button type="button" @click="refreshOptions()" class="btn btn-sm btn-info">
              <i class="mdi mdi-refresh"></i>
              Refresh Options
            </button>
          </div>
        </div>
        <div class="mb-3" v-if="selectedDU.withDeliveryUnitAccess || $store.state.decrypt.isAdmin()">
          <label>Send As</label>
          <b-form-radio-group v-model="selectedSendAs" :options="sendAsOptions" name="send-as-options" plain>
          </b-form-radio-group>
        </div>
        <div class="mb-3">
          <label for="title">Title </label>
          <input id="title" type="text" v-model="form.title" placeholder="Enter Title..." class="form-control" :class="{
            'is-invalid': submitted && $v.form.title.$error
          }" autocomplete="off" />
          <div v-if="submitted && $v.form.title.$error" class="invalid-feedback">
            <span v-if="!$v.form.title.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label for="description">Description </label>
          <textarea id="description" type="text" v-model="form.description" placeholder="Enter Description..."
            class="form-control" :class="{
              'is-invalid': submitted && $v.form.description.$error
            }" autocomplete="off" />
          <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
            <span v-if="!$v.form.description.required">This value is required.</span>
          </div>
        </div>
        <div class="mb-3">
          <label class="mt-2" for="documents">Particulars </label>
          <div>
            <b-input-group>
              <template #append>
                <button @click="addDocument()" class="btn btn-success">
                  Add
                </button>
              </template>
              <input autocomplete="off" type="text" placeholder="Enter Particular..." class="form-control" :class="{
                'is-invalid': submitted && form.documents.length == 0
              }" v-model="form.document" />
            </b-input-group>
            <div v-if="submitted && form.documents.length == 0" class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <div v-if="form.documents.length > 0" class="mx-3 mt-2 p-2 br-5 border position-relative"
            style="min-height: 40px; background-color: #2e3446">
            <div class="w-100" style="top: 10px; left: 10px; bottom: 10px; right: 10px">
              <div class="multiselect__tags-wrap">
                <span class="multiselect__tag" v-for="(document, index) in form.documents" :key="document.id">
                  <span>{{ document }}</span>
                  <i class="multiselect__tag-icon" @click="removeDocument(index)"></i></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <label>Process </label>
          <multiselect id="processType" v-model="form.processType" track-by="processName" label="processName"
            placeholder="Select Process..." :custom-label="processTypeLabel" :show-labels="false"
            :options="processTypeOptions" :searchable="true" :multiple="false" :allow-empty="false"
            :close-on-select="true" :class="{
              'is-invalid': submitted && $v.form.processType.$error
            }" @input="changeProcessType()">
          </multiselect>
          <div v-if="submitted && $v.form.processType.$error" class="invalid-feedback">
            <span v-if="!$v.form.processType.required">This value is required.</span>
          </div>
        </div>
        <b-collapse :visible="form.processType != null">
          <div v-if="form.processType != null">
            <div class="mb-3">
              <label>Action Request/Purpose </label>
              <multiselect id="actionType" v-model="form.actionType" track-by="type" label="type"
                placeholder="Select Action Request/Purpose..." :custom-label="actionTypeLabel" :show-labels="false"
                :options="actionTypeOptions" :searchable="true" :multiple="false" :allow-empty="false"
                :close-on-select="true" :class="{
                  'is-invalid': submitted && $v.form.actionType.$error
                }">
              </multiselect>
              <b-collapse :visible="form.actionType && form.actionType.type == 'Others'">
                <div v-if="form.actionType && form.actionType.type == 'Others'" class="mx-3 mt-2">
                  <input id="title" type="text" v-model="form.actionNeeded"
                    placeholder="Enter Action Request/Purpose..." class="form-control" :class="{
                      'is-invalid':
                        submitted &&
                        form.actionType.type == 'Others' &&
                        form.actionNeeded == ''
                    }" autocomplete="off" />
                </div>
              </b-collapse>
              <div v-if="
                submitted &&
                ($v.form.actionType.$error ||
                  (form.actionType.type == 'Others' &&
                    form.actionNeeded == ''))
              " class="invalid-feedback">
                <span v-if="!$v.form.actionType.required">This value is required.</span>
              </div>
            </div>
            <label>Destination </label>
            <div class="border mb-3 px-3 py-2" style="border-radius: 5px">
              <div class="mb-3">
                <div class="d-flex justify-content-between">
                  <label>{{ GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office' }} </label>
                  <div class="form-check form-checkbox-outline form-check-success mb-0">
                    <input type="checkbox" id="showAll" class="form-check-input" v-model="showAllCampus" />
                    <label for="showAll" class="form-check-label no-wrap">
                      Show All
                    </label>
                  </div>
                </div>
              </div>
              <multiselect id="destinationCampus" v-model="form.destinationCampus" track-by="campus" label="campus"
                :placeholder="`Select ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}...`" :custom-label="campusLabel"
                :show-labels="false" :options="campusOptions" :searchable="true" :multiple="false" :allow-empty="false"
                :close-on-select="true" :class="{
                  'is-invalid': submitted && $v.form.destinationCampus.$error
                }">
              </multiselect>
              <div v-if="submitted && $v.form.destinationCampus.$error" class="invalid-feedback">
                <span v-if="!$v.form.destinationDeliveryUnit.required">This value is required.</span>
              </div>
            </div>
            <b-collapse :visible="form.destinationCampus != null">
              <div v-if="form.destinationCampus != null">
                <div class="mb-3">
                  <label>Office </label>
                  <multiselect id="destinationDeliveryUnit" v-model="form.destinationDeliveryUnit" track-by="name"
                    label="name" placeholder="Select Office..." :custom-label="deliveryUnitLabel" :show-labels="false"
                    :options="form.destinationCampus.deliveryUnitOptions" :searchable="true" :multiple="false"
                    :allow-empty="false" :close-on-select="true" @input="getDepartment(form.destinationDeliveryUnit.id)"
                    :class="{
                      'is-invalid':
                        submitted && $v.form.destinationDeliveryUnit.$error
                    }">
                  </multiselect>
                  <div v-if="submitted && $v.form.destinationDeliveryUnit.$error" class="invalid-feedback">
                    <span v-if="!$v.form.destinationDeliveryUnit.required">This value is required.</span>
                  </div>
                </div>
                <b-collapse :visible="form.destinationDeliveryUnit != null">
                  <div v-if="form.destinationDeliveryUnit != null">
                    <div class="mb-2">
                      <label>Department </label>
                      <multiselect id="destinationDepartment" v-model="form.destinationDepartment"
                        track-by="departmentName" label="departmentName" placeholder="Select Department..."
                        :custom-label="departmentLabel" :show-labels="false" :options="departmentOptions"
                        :searchable="true" :multiple="false" :allow-empty="false" :close-on-select="true">
                      </multiselect>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
        <div class="mb-3">
          <div class="d-flex float-end">
            <button type="button" @click="getTracks()" class="btn btn-sm btn-success">
              Select Tracks
            </button>
          </div>
          <label class="mt-2">Link Track</label>
          <hr class="mt-1 mb-2" />
          <div style="max-height: 180px; overflow: auto" class="pe-2">
            <table v-if="form.tracks.length > 0" width="100%">
              <tbody>
                <tr v-for="(item, index) in form.tracks" :key="index">
                  <td class="py-2">
                    <div class="d-flex">
                      <div class="me-3">{{ index + 1 }}.</div>
                      <div>
                        <small>{{ item.referenceNumber }}</small>
                        <div>{{ item.title }}</div>
                      </div>
                    </div>
                  </td>
                  <td class="py-2" style="width: max-content">
                    <a href="javascript: void(0);" class="text-danger" @click="form.tracks.splice(index, 1)">
                      <i class="bx bx-x font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
            <i class="font-size-11" v-else>No Tracks Linked</i>
          </div>
          <hr class="my-2" />
        </div>
        <div class="d-flex float-end gap-1">
          <button @click="onSubmit('create')" class="btn btn-primary">
            Create as Draft
          </button>
          <button @click="onSubmit('send')" class="btn btn-success">
            Create & Send
          </button>
        </div>
      </div>
    </b-modal>

    <!-- Process Tracking Card -->
    <div class="card">
      <div class="card-body">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h4 class="card-title mb-0">Process Tracking</h4>
          <button type="button" @click="createTrack()" class="btn btn-sm btn-success d-inline-flex align-items-center">
            <i class="bx bx-plus fs-6 me-1"></i>Create Track
          </button>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <div class="d-flex gap-3">
              <router-link id="officeTracks" v-if="selectedDU.withDeliveryUnitAccess || $store.state.decrypt.isAdmin()"
                to="/dts/incoming-tracks" class="border border-r-5px py-2 px-3 text-decoration-none position-relative"
                style="flex: 1; transition: all 0.2s ease;"
                onmouseover="this.classList.add('shadow-lg'); this.querySelector('.track-number').classList.add('text-info'); this.querySelector('.track-number').classList.remove('text-muted'); this.querySelector('p').classList.add('text-info'); this.querySelector('p').classList.remove('text-muted'); this.style.borderColor='#50a5f1';"
                onmouseout="this.classList.remove('shadow-lg'); this.querySelector('.track-number').classList.remove('text-info'); this.querySelector('.track-number').classList.add('text-muted'); this.querySelector('p').classList.remove('text-info'); this.querySelector('p').classList.add('text-muted'); this.style.borderColor='';">
                <div class="text-center">
                  <h5 class="font-size-15 track-number text-muted mb-1">{{ officeIncomingCount }}</h5>
                  <p class="text-muted small mb-0">Office Tracks</p>
                </div>
              </router-link>

              <router-link to="/dts/dept-incoming-tracks"
                class="border border-r-5px py-2 px-3 text-decoration-none position-relative"
                style="flex: 1; transition: all 0.2s ease;"
                onmouseover="this.classList.add('shadow-lg'); this.querySelector('.track-number').classList.add('text-info'); this.querySelector('.track-number').classList.remove('text-muted'); this.querySelector('p').classList.add('text-info'); this.querySelector('p').classList.remove('text-muted'); this.style.borderColor='#50a5f1';"
                onmouseout="this.classList.remove('shadow-lg'); this.querySelector('.track-number').classList.remove('text-info'); this.querySelector('.track-number').classList.add('text-muted'); this.querySelector('p').classList.remove('text-info'); this.querySelector('p').classList.add('text-muted'); this.style.borderColor='';">
                <div class="text-center">
                  <h5 class="font-size-15 track-number text-muted mb-1">{{ departmentIncomingCount }}</h5>
                  <p class="text-muted small mb-0">Department Tracks</p>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <div>
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="text-muted">Track Search</span>
          </div>
          <div class="input-group">
            <input autocomplete="off" type="text" class="form-control" placeholder="Input Tracking Number..."
              v-model="referenceNumber" v-on:keyup.enter="getTrack" />
            <button type="button" @click="getTrack" class="btn btn-primary">
              <i class="bx bx-search fs-6 me-1"></i>Get Track
            </button>
          </div>
          <p class="text-muted mb-0 mt-1">
            <small><i class="bx bx-info-circle me-1"></i>Enter a valid tracking number to search</small>
          </p>
        </div>
      </div>
    </div>
    <Details ref="details"></Details>
    <Tracks ref="tracks" @dropMultiple="dropTracks($event)"></Tracks>
    <CreateDetails user="office" @updateTrack="updateTrack($event)" @postTrack="postTrack($event)"
      @unsendTrack="unsendTrack($event)" @deleteTrack="deleteTrack($event)"
      @printTrackingReport="printSingleTrackingReport($event)" ref="createDetails"></CreateDetails>
    <print-options ref="printOpt"></print-options>
  </div>
</template>